import { MetaData } from '../MetaData';
import { isUndefined } from 'util';
/**
 * class {PriceLevel}
 * should be used to describe the different variants of a ticket that
 * can be bought if the needed requirements are fulfilled
 */
export class PriceLevel extends MetaData {
    /**
     * constructor of class
     * please use factory instead
     * @see {this.factory)
     * @param id
     * @param price
     */
    constructor(id, name, price, requirements, metaData) {
        super(metaData);
        this._id = id;
        this._name = name;
        this._price = price;
        this._requirements = requirements;
    }
    /**
     * Factory method to create an instance of this class without
     * having to correctly fill the constructor.
     * !!! You should always use this instead of the constructor !!!
     * @param values Object of values to inflate the object with
     * @returns {PriceLevel}
     */
    static factory(values) {
        const sanitizedValues = {};
        sanitizedValues.id = values.id || '';
        sanitizedValues.name = values.name || '';
        sanitizedValues.price = values.price || 0;
        sanitizedValues.requirements = values.requirements || [];
        sanitizedValues.metaData = !isUndefined(values.metaData) ? values.metaData : {};
        return new PriceLevel(sanitizedValues.id, sanitizedValues.name, sanitizedValues.price, sanitizedValues.requirements, sanitizedValues.metaData);
    }
    /**
     * gets the internal _id
     * @returns {string}
     */
    get id() {
        return this._id;
    }
    /**
     * sets the internal _id
     * @param value
     */
    set id(value) {
        this._id = value;
    }
    /**
     * gets name for current ticket
     * @returns {string}
     */
    get name() {
        return this._name;
    }
    /**
     * sets name of current ticket
     * @param value
     */
    set name(value) {
        this._name = value;
    }
    /**
     * gets price for current ticket
     * @returns {string}
     */
    get price() {
        return this._price;
    }
    /**
     * sets price of current ticket
     * @param value
     */
    set price(value) {
        this._price = value;
    }
    /**
     * gets requirements for the current ticket
     * @returns {TicketRequirements[]}
     */
    get requirements() {
        return this._requirements;
    }
    /**
     * sets requirements for the current ticket
     * @param value
     */
    set requirements(value) {
        this._requirements = value;
    }
}
//# sourceMappingURL=priceLevel.js.map